// extracted by css-extract-rspack-plugin
export default {"copyButton":"SGIUn"};